export { Menu as default } from './Menu';
